import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { List, CreditCard, CalendarBlank, Bank, Checks, SignOut } from 'phosphor-react'
import * as S from './styles'

export type MenuKey = 'vendas' | 'recebimentos' | 'extrato' | 'conciliacao'

type NavItem = {
  key: MenuKey
  label: string
  icon: JSX.Element
  path: string
}

const items: NavItem[] = [
  { key: 'vendas', label: 'Vendas', icon: <CreditCard size={30} weight="fill" />, path: '/dashboard' },
  { key: 'recebimentos', label: 'Recebimentos', icon: <CalendarBlank size={30} />, path: '/recebimentos' },
  { key: 'extrato', label: 'Extrato Bancário', icon: <Bank size={30} />, path: '/extrato' },
  { key: 'conciliacao', label: 'Conciliação Bancária', icon: <Checks size={30} />, path: '/conciliacao' },
]

type Props = { active: MenuKey }

const SideMenu: React.FC<Props> = ({ active }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const history = useHistory()

  const sidebarStyle: React.CSSProperties = {
    flexBasis: menuOpen ? 256 : 68,
  }
  const itemStyle: React.CSSProperties = {
    justifyContent: menuOpen ? 'flex-start' : 'center',
    gap: menuOpen ? 14 : 0,
    padding: menuOpen ? '0 14px' : 0,
  }
  const labelStyle: React.CSSProperties = {
    maxWidth: menuOpen ? 190 : 0,
    opacity: menuOpen ? 1 : 0,
  }

  const go = (path: string) => {
    // preserva a query (ex.: ?grupo=NOME do acesso do cliente) ao trocar de tela
    const search = history.location.search
    if (path && history.location.pathname !== path) history.push({ pathname: path, search })
  }

  const sair = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('cliente')
    // tambem zera os filtros compartilhados (periodo/empresa) para nao vazarem p/ o proximo login
    localStorage.removeItem('painel.periodo')
    localStorage.removeItem('painel.empresas')
    // sai para o login. window.top cobre o caso desta tela estar dentro do iframe
    // do /painel (mesma origem) — redireciona a janela inteira, nao so o iframe.
    try {
      ;(window.top || window).location.href = '/'
    } catch {
      window.location.href = '/'
    }
  }

  return (
    <S.Sidebar style={sidebarStyle}>
      <S.SideItem
        style={itemStyle}
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Abrir menu"
      >
        <List size={30} />
        <span className="label" style={labelStyle}>
          Menu
        </span>
      </S.SideItem>

      {items.map((it) => (
        <S.SideItem
          key={it.key}
          style={itemStyle}
          active={active === it.key}
          onClick={() => go(it.path)}
        >
          {it.icon}
          <span className="label" style={labelStyle}>
            {it.label}
          </span>
        </S.SideItem>
      ))}

      <S.SideSpacer />

      <S.SideItem style={itemStyle} onClick={sair} aria-label="Sair">
        <SignOut size={30} />
        <span className="label" style={labelStyle}>
          Sair
        </span>
      </S.SideItem>
    </S.Sidebar>
  )
}

export default SideMenu
